import Stock from '#components/Stock.js';

export const Footer = ({ isAuth, user }) => {
  const loggedIn = Boolean(isAuth && user);

  return (
    <>
      <style>{`
        /* ====== LEGAL sin sesión: base (móvil / tablet) ====== */
        .footer__legal-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          flex-wrap: wrap;
          width: 100%;
          text-align: center;
        }
        .footer__legal-left {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        .footer__legal-link { white-space: nowrap; }

        .footer__legal-logos {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          flex-wrap: wrap;            /* móvil: permite salto */
        }
        .footer__brand-img {
          height: clamp(42px, 6vw, 64px);
          width: auto;
          object-fit: contain;
          display: block;
        }

        /* ====== Desktop ====== */
        @media (min-width: 992px) {
          .footer__legal-row {
            justify-content: flex-start;   /* bloque izquierda queda a la izq */
            flex-wrap: nowrap;             /* TODO en una línea */
            gap: 24px;
            text-align: left;
          }
          .footer__legal-left { 
            flex-wrap: nowrap; 
            gap: 24px; 
          }
          .footer__legal-left h3 { margin: 0; white-space: nowrap; }
          .footer__legal-link { white-space: nowrap; }

          /* Empuja logos a la DERECHA y NO permite que se apilen */
          .footer__legal-logos {
            margin-left: auto;             /* logos a la derecha */
            flex-wrap: nowrap !important;  /* no se apilan */
            gap: 20px;
          }
          .footer__legal-logos > a,
          .footer__legal-logos > img {
            display: inline-flex;          /* aseguro inline-flex para el <a> */
          }
          .footer__brand-img {
            height: 56px;                  /* misma altura para los dos logos */
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer__info">
          <div className="container">
            <div className="row">
              {loggedIn ? (
                <>
                  {/* Columna: Logo + Redes */}
                  <div className="col col-33 col-mb-50 col-100-sm-mb">
                    <div className="center-block imglog">
                      <img
                        src="../img/logo-tecnosuper-aliados2.png"
                        alt="TecnoAliados"
                      />
                    </div>
                    <div className="footer__social-network">
                      <div className="footer__cont-social-network">
                        <a
                          href="https://api.whatsapp.com/send/?phone=%2B573011778476&text&type=phone_number&app_absent=0"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="WhatsApp"
                        >
                          <i className="fa-brands fa-whatsapp"></i>
                        </a>
                      </div>
                      <div className="footer__cont-social-network">
                        <a
                          href="https://www.facebook.com/TecnoSuper0/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Instagram"
                        >
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </div>
                      <div className="footer__cont-social-network">
                        <a
                          href="https://www.youtube.com/@USAMS_GLOBAL"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="YouTube"
                        >
                          <i className="fa-brands fa-youtube"></i>
                        </a>
                      </div>
                      <div className="footer__cont-social-network">
                        <a
                          href="https://www.tiktok.com/tag/usams"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="TikTok"
                        >
                          <i className="fa-brands fa-tiktok"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Columna: Contáctanos */}
                  <div className="col col-33 col-mb-50 col-100-sm-mb">
                    <div className="footer__contact">
                      <h3>CONTÁCTANOS</h3>
                      <ul>
                        <li>
                          <span>Atención al cliente:</span> Lunes a Viernes 8am
                          - 6pm
                        </li>
                        <li>
                          <span>Correo:</span> facturas@chacam.co
                        </li>
                        <li>
                          <span>Dirección:</span> Km 3.6 Vía La Ceja - Rionegro,
                          Mall Cantarrana Local 22
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Columna: Legal (con sesión) */}
                  <div className="col col-33 col-mb-50 col-100-sm-mb ">
                    <div className="footer__rights">
                      <h3>LEGAL</h3>
                      <a
                        href="https://www.tecnosuper.co/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Política de Tratamiento de datos
                      </a>
                      <div className="footer__brands">
                        <img
                          src="../img/Logo Industria y Comercio.svg"
                          alt="Superintendencia de Industria y Comercio"
                          className="footer__brand-img"
                        />
                        <a
                          target="blank"
                          href="https://asincode.co"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="../img/logo-asincode.png"
                            alt="Asincode"
                            className="footer__brand-img"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                /* ===== SIN SESIÓN: LEGAL izquierda | LOGOS derecha (desktop), centrado en mobile ===== */
                <div className="col col-100 col-mb-100">
                  <div className="footer__rights footer__legal-row">
                    <div className="footer__legal-left">
                      <h3>LEGAL</h3>
                      <a
                        className="footer__legal-link"
                        href="https://www.tecnosuper.co/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Política de Tratamiento de datos
                      </a>
                    </div>

                    <div className="footer__legal-logos">
                      <img
                        src="../img/Logo Industria y Comercio.svg"
                        alt="Superintendencia de Industria y Comercio"
                        className="footer__brand-img"
                      />
                      <a
                        target="blank"
                        href="https://asincode.co"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="../img/logo-asincode.png"
                          alt="Asincode"
                          className="footer__brand-img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Franja inferior (siempre visible) */}
        <div className="footer__text">
          <span>
            Copyright &copy; {new Date().getFullYear()} Desarrollado por{' '}
            <b>
              <a
                target="blank"
                href="https://asincode.co"
                rel="noopener noreferrer"
              >
                Asincode.
              </a>
            </b>
          </span>
        </div>
      </footer>

      {/* Loader */}
      <div className="load load-display">
        <div className="center-block logo-display">
          <img src="../img/logo-tecnosuper-aliados1.png" alt="Tecnosuper" />
        </div>
        <div className="loader"></div>
      </div>

      {/* Stock solo si hay sesión */}
      {loggedIn && <Stock isAuth={isAuth} user={user} />}
    </>
  );
};
